import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ServicePage from "../pages/servico/page";
import BlogPage from "../pages/blog/page";
import ConvitePage from "../pages/convite/page";
import FariaLimaBlogPage from "../pages/faria-lima-blog/page";
import FariaLimaPostPage from "../pages/faria-lima-post/page";
import FariaLimaLandingPage from "../pages/faria-lima/page";
import ContatoRecebidoPage from "../pages/contato-recebido/page";
import WppConfirmadoPage from "../pages/wpp-confirmado/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/servicos/:slug",
    element: <ServicePage />,
  },
  {
    path: "/blog/:slug",
    element: <BlogPage />,
  },
  {
    path: "/blog-faria-lima",
    element: <FariaLimaBlogPage />,
  },
  {
    path: "/blog-faria-lima/:slug",
    element: <FariaLimaPostPage />,
  },
  {
    path: "/faria-lima",
    element: <FariaLimaLandingPage />,
  },
  {
    path: "/contato-recebido",
    element: <ContatoRecebidoPage />,
  },
  {
    path: "/wpp-confirmado",
    element: <WppConfirmadoPage />,
  },
  {
    path: "/convite",
    element: <ConvitePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;